import aboutImage from '../assets/home/abouts.png';
import pastorImage from '../assets/home/pastorpic.png';
import aboutBackground from '../assets/home/aboutBackground.png';
import storyPastorImage from '../assets/story/pastor_aunty.png';

export const EDITOR_IMAGE_DEFAULTS = {
  'home.about.image': aboutImage,
  'home.pastor.image': pastorImage,
  'home.pastor.background': aboutBackground,
  'story.pastor_image': storyPastorImage,
};

export function getEditorImageDefault(contentKey) {
  return EDITOR_IMAGE_DEFAULTS[contentKey] || '';
}
